import { Module } from 'vuex'
import { RootState } from 'surface/xstore/types'
import { CONFIRM_DISCARD_CHANGES } from 'bits/confirmation_dialog'

enum ShareSubpanel {
  Main = 'main',
  Lti = 'ltiSettings',
  Embed = 'embed',
  Privacy = 'privacy',
  Members = 'members',
}
interface SharePanelState {
  activePanel: null | ShareSubpanel
  isQrModalOpen: boolean
}

const ShareModule: Module<SharePanelState, RootState> = {
  namespaced: true,
  state: {
    activePanel: null,
    isQrModalOpen: false,
  },
  getters: {
    isOpen (state): boolean {
      return state.activePanel !== null
    },
    isQrModalOpen (state): boolean {
      return state.isQrModalOpen
    },
    activePanel (state): null | ShareSubpanel {
      return state.activePanel
    },
  },
  mutations: {
    HIDE_SHARE_PANEL (state): void {
      state.activePanel = null
      state.isQrModalOpen = false
    },
    SHOW_SHARE_PANEL (state, panel: ShareSubpanel): void {
      state.activePanel = panel
    },
    OPEN_QR_MODAL (state): void {
      state.isQrModalOpen = true
    },
    CLOSE_QR_MODAL (state): void {
      state.isQrModalOpen = false
    },
  },
  actions: {
    showSharePanel ({ commit }): void {
      commit('SHOW_SHARE_PANEL', ShareSubpanel.Main)
    },
    hideSharePanel ({ commit }): void {
      commit('HIDE_SHARE_PANEL')
    },
    resetSharePanel ({ dispatch, commit }): void {
      commit('HIDE_SHARE_PANEL')
      dispatch('privacySettings/resetWallPrivacy', null, { root: true })
    },
    confirmResetSharePanel ({ dispatch,  rootGetters }): void {
      if (rootGetters['privacySettings/isDirty']) {
        const options = {
          ...CONFIRM_DISCARD_CHANGES,
          afterConfirmActions: [
            { type: 'share/hideSharePanel' },
          ],
        }
        dispatch('confirmationDialog/openConfirmationDialog', options, { root: true })
      } else {
        dispatch('hideSharePanel')
      }
    },
    changeActivePanel ({ commit }, panel: ShareSubpanel): void {
      commit('SHOW_SHARE_PANEL', panel)
    },
    confirmChangePanelDiscardChanges ({ dispatch, rootGetters }, panel: ShareSubpanel): void {
      if (rootGetters['privacySettings/isDirty']) {
        const options = {
          ...CONFIRM_DISCARD_CHANGES,
          afterConfirmActions: [
            { type: 'share/changeActivePanel', payload: panel },
            { type: 'privacySettings/discardWallPrivacyChanges' },
          ],
        }
        dispatch('confirmationDialog/openConfirmationDialog', options, { root: true })
      } else {
        dispatch('changeActivePanel', panel)
        dispatch('privacySettings/discardWallPrivacyChanges', null, { root: true })
      }
    },
    toggleSharePanel ({ commit, getters }, panel: ShareSubpanel): void {
      if (getters.isOpen) {
        commit('HIDE_SHARE_PANEL')
      } else {
        commit('SHOW_SHARE_PANEL', panel)
      }
    },
    openQrModal ({ commit }): void {
      commit('OPEN_QR_MODAL')
    },
    closeQrModal ({ commit }): void {
      commit('CLOSE_QR_MODAL')
    },
  },
}

export default ShareModule
export {
  ShareSubpanel,
  SharePanelState,
}
